import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { BodyListResponse } from '../../../../core/models/general/body-list-response';
import { ResultadoConsolidadoDTO } from '../../../../core/models/evaluacion/resultadoConsolidado-DTO';
import { BodyResponse } from '../../../../core/models/general/body-response';

const API_URL = environment.apiUrlEvaluacion;

@Injectable()
export class ResultadoConsolidadoService {
    header = new Headers({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) {}

    getResultadoConsolidadoService() {
        return this.http.get<BodyListResponse<ResultadoConsolidadoDTO>>(
            API_URL + '/api/v1/resultadoConsolidado/todos'
        );
    }

    guardarResultadoConsolidadoService(resultadoConsolidadoDTO: ResultadoConsolidadoDTO) {
        return this.http.post(API_URL + '/api/v1/resultadoConsolidado', resultadoConsolidadoDTO);
    }

    getResultadoConsolidadoPorCodigoResultadoConService(codigoResultadoCon: String) {
        return this.http.get<BodyResponse<ResultadoConsolidadoDTO>>(
            API_URL + '/api/v1/resultadoConsolidado/' + codigoResultadoCon
        );
    }
}
